import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Repeat2, Truck } from 'lucide-react';
import { toast } from 'sonner';
import { api, errorText } from '../api';
import { useDraft } from '../context';
import { Action, DownloadButton, Field } from '../ui';
import { NEXT_ORDER_STATUS } from './OrderProgress';

async function productRequestLine(item) {
  const { data: product } = await api.get(`/products/${item.product_id}`);
  return { product, quantity: item.quantity };
}

const RepeatRequest = ({ order }) => {
  const { addItems } = useDraft();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  async function reorder() {
    setBusy(true);
    try {
      const items = await Promise.all(order.items.map(productRequestLine));
      addItems(items);
      navigate('/rfq');
    } catch (error) { toast.error(errorText(error)); }
    finally { setBusy(false); }
  }
  return <Action id={`reorder-${order.id}`} secondary busy={busy} onClick={reorder}><Repeat2 size={15} />Repeat request</Action>;
};

export const OrderDocuments = ({ order, user }) => <div className="order-actions">
  <DownloadButton path={`/orders/${order.id}/document`} name={`${order.number}.txt`} id={`download-po-${order.id}`}>Download purchase order</DownloadButton>
  {order.po_file_id && <DownloadButton path={`/files/${order.po_file_id}`} name="purchase-order-attachment"
    id={`download-po-attachment-${order.id}`}>Buyer PO attachment</DownloadButton>}
  {user.role === 'buyer' && <RepeatRequest order={order} />}
</div>;

const FulfillmentForm = ({ order, nextStatus, reload }) => {
  const [tracking, setTracking] = useState(order.tracking);
  const [busy, setBusy] = useState(false);
  async function update(event) {
    event.preventDefault();
    setBusy(true);
    try {
      await api.patch(`/orders/${order.id}`, { status: nextStatus, tracking });
      toast.success('Fulfillment updated');
      reload();
    } catch (error) { toast.error(errorText(error)); }
    finally { setBusy(false); }
  }
  return <form onSubmit={update} className="fulfillment-form">
    {nextStatus === 'dispatched' && <Field id={`dispatch-tracking-${order.id}`} label="Carrier & tracking reference"
      placeholder="Carrier name · AWB / consignment number" required value={tracking} onChange={event => setTracking(event.target.value)} />}
    <Action id={`fulfill-${order.id}`} type="submit" busy={busy}>Mark as {nextStatus}<Truck size={16} /></Action>
  </form>;
};

export const OrderFulfillment = ({ order, user, reload }) => {
  const nextStatus = NEXT_ORDER_STATUS[order.status];
  if (user.role !== 'supplier' || !nextStatus) return null;
  return <FulfillmentForm order={order} nextStatus={nextStatus} reload={reload} />;
};